<template>
  <div>
    <!-- API request Received -->
    <template v-if="gotKings">
    <v-fade-transition>
      <v-badge
        v-if="showKings"
        overlap
        bordered
        color="#7489a1"
        class="badgeCard"
        offset-x="33"
        offset-y="25"
      >
        <v-btn 
          id="hiddenBtn_deleteKings" 
          slot="badge"
          @click.native="showKings = false"
        >
          <v-icon id="icon_deleteKings">fas fa-times</v-icon>
        </v-btn>

        <v-card
          class="mx-auto mt-3 mb-3 mr-5 ml-5"
          raised
        >
          <v-list subheader>
            <v-subheader>{{ $t("kings.title") }}</v-subheader>
            <v-divider></v-divider>
            <v-list-item

              v-for="(king, index) in kings"
              :key="king.username"
            >
            <v-list-item-icon>
                <v-icon
                  small
                  :color="colorExtraction(index)"
                >
                  {{iconExtraction(king.id)}}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title style="white-space: break-spaces; !important"> <!-- Allow multiple lines-->
                  {{king.username}} {{ $t("kings.has") }} {{king.total}} {{ $t("kings.victims") }} <font size="1">{{ $t("kings.24h") }}</font>
                </v-list-item-title>
              </v-list-item-content>

              <!--<v-list-item-avatar>
                <v-img src="https://cdn.vuetifyjs.com/images/lists/2.jpg"></v-img>
              </v-list-item-avatar>-->

            </v-list-item>
          </v-list>
        </v-card>
      </v-badge>
    </v-fade-transition>
    </template>

    <!-- API request Not Received -->
    <template v-else> <!-- Loading ... -->
      <v-row no-gutters>
        <v-col>
          <v-skeleton-loader
            class="mx-auto mb-3 mt-3 mr-5 ml-5"
            max-width="500"
            type="paragraph"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<style scoped>
  #hiddenBtn_deleteKings{
    background: none;
      height: 12px;
      padding: 0px;
      max-width: 0px;
      min-width: 0px;
      z-index: 2
  }
  #icon_deleteKings{
    color: white !important;
  }
  .badgeCard{
    width: 100%;
  }
</style>

<script>
import King from "@/apis/King";

export default {
  data () {
    return {
      gotKings : false,
      showKings: true,
      kings : [],
    }
  },

  methods: {
    /**
    * Get Kings list
    */
    getKings(){
      King.getAll()
      .then(response => {
        this.kings = response.data;
        this.gotKings = true;
      })
    },

    /**
    * Get King User icon
    */
    iconExtraction(key){
        switch (key) {
        case 1:
          return 'fa-dragon';
        case 2:
          return 'fa-spider';
        case 3:
          return 'fa-horse-head';
        default:
          return 'fa-crown';
      }
    },

    /**
    * Get King User color icon
    */
    colorExtraction(key){
        switch (key) {
        case 0:
          return '#1976d2';
        case 1:
          return '#65a9ed';
        case 2:
          return '#aad0f5';
        default:
          return '#000000';
      }
    }
  },
  mounted(){
    /**
    * Show kings
    */
    this.getKings();
  }
};
</script>